/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import "./style.scss";
import {
  Spin,
  Input,
  Select,
  Row,
  Col,
  Button,
  Table,
  DatePicker,
  Dropdown,
  Checkbox,
  Menu,
  message,
} from "antd";
import filter_icon from ".././../assests/images/filterIconforManifest.svg";
import API from "../../api";
import { APIs } from "../../utils/worker";
import {
  capitalize,
  serialNum,
  capitaliseWithHyphen,
  convertDate,
} from "../../utils";

function GenerateManifest({ manifrestId, changeTab }) {
  const [loading, setLoading] = useState(false);
  const [cpDropDown, setCpDropDown] = useState([]);
  const [selectedCp, setSelectedCp] = useState("");
  const [tableData, setTableData] = useState([]);
  const [toFilter, setToFilter] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [cpName, setCpName] = useState(null);
  const [manifestData, setManifestData] = useState();

  console.log(toFilter);
  let hubid = JSON.parse(localStorage.getItem("userId"));

  useEffect(() => {
    getCP();
  }, []);

  useEffect(() => {
    if (Object.keys(manifrestId).length !== 0) {
      getTableData(manifrestId);
      setCpName(manifrestId?.name);
    }
  }, [manifrestId]);

  const getCP = async () => {
    setLoading(true);
    let response = await API.Api(
      `${APIs.baseURL}/premise-service/v1/premise/hub-cp-details/${hubid?.userInfo?.premiseId}`
    ).getWithAllHeaders();
    if (response.status) {
      setCpDropDown(response?.response?.data);
      setLoading(false);
    } else {
      if (!response.status) {
        message.error(response.response.data.message || "Network error");
        setLoading(false);
      }
    }
  };

  const getTableData = async (manifrestId) => {
    setLoading(true);
    let response = await API.Api(
      `${APIs.baseURL}/v1/packets/elligible-to-cp/${manifrestId?.toPremise}`
    ).getWithUserNPremiseHeader();

    if (response?.status) {
      let shipment = response?.response?.data?.shipments;
      let child = response?.response?.data?.childShipmentDetails;
      for (let i = 0; i < child.length; i++) {
        child[i].awbNumber = child[i].childAwbNumber;
        child[i].childPacket = "Yes";
        child[i].type = "Non-Dox";
      }
      for (let i = 0; i < shipment.length; i++) {
        shipment[i].childPacket = "No";
      }
      let temp = [...shipment, ...child];

      setTableData(temp);
      // setToFilter(temp);
      setLoading(false);
    } else {
      if (!response.status) {
        setLoading(false);
      }
    }
  };

  const handleScan = async () => {
    setLoading(true);
    let payload = {
      type: "pickup",
      status: "UNLOCKED",
      toPremise: selectedCp,
      cpName: cpName,
      travelBy: "surface",
    };
    let response = await API.Api(
      `${APIs.baseURL}/last-mile-manifest-service/v1/manifest`
    ).postIdHeader(payload);
    if (response.status) {
      setManifestData(response?.response?.data);
      getTableData(response?.response?.data);
      setLoading(false);
    } else {
      setLoading(false);
      setTableData([]);
      message.error(response?.response?.data?.message || "Network error");
    }
  };

  const onChange = (value, obj) => {
    // setLoading();
    setCpName(obj?.children);
    setSelectedCp(value);
  };
  const onSearch = (value) => {
    console.log("search:", value);
  };

  const columns = [
    {
      title: "Sl No",
      align: "center",
      // width: 10,
      render: (a, b, idx) => serialNum(10, 1, idx),
    },
    {
      title: "AWB Number",
      dataIndex: "awbNumber",
      key: "awbNumber",
      render: (text) => <text>{text}</text>,
    },
    {
      title: "In scan Date",
      dataIndex: "updatedDate",
      key: "updatedDate",
      render: (text) => <text>{convertDate(text)}</text>,
    },
    {
      title: "Doc Type",
      dataIndex: "type",
      key: "type",
      render: (text) => (
        <text>
          {" "}
          {/* {text !== null && typeof text !== "number"
            ? capitaliseWithHyphen(text)
            : text} */}
          {/* {typeof text !== "number" ? text : text} */}
          {capitaliseWithHyphen(text)}
        </text>
      ),
    },
    {
      title: "Child Packets",
      key: "childPacket",
      dataIndex: "childPacket",
    },
  ];

  const { RangePicker } = DatePicker;

  let arr = ["Dox", "Non-Dox"];

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const [filteredData, setFilteredData] = useState([]);

  let newFun = (e) => {
    let temp = [];
    for (let j = 0; j < e.length; j++) {
      for (let i = 0; i < tableData.length; i++) {
        if (tableData[i].type.toLowerCase() == e[j].toLowerCase()) {
          temp.push(tableData[i]);
        }
      }
    }
    setToFilter(temp);
  };

  const changeCheck = (e, x) => {
    let cur = e.target.value.toLowerCase();
    if (filteredData.includes(cur)) {
      let temp1 = filteredData.filter((item) => item !== cur);
      newFun(temp1);
      setFilteredData(temp1);

      // setFilteredData(tableData.filter);
    } else {
      let temp = [...filteredData, cur];
      newFun(temp);

      setFilteredData(temp);
    }
  };

  const menu = (
    <Menu
      style={{ cursor: "default", backgroundColor: "#fff" }}
      items={[
        ...arr.map((item, index) => ({
          label: (
            <Checkbox
              onChange={(e) => changeCheck(e)}
              key={"drop_" + index}
              value={item}
            >
              &nbsp;<span>{item}</span>
            </Checkbox>
          ),
          key: { index },
          style: { fontSize: "14px", cursor: "default" },
        })),
      ]}
    />
  );

  const { Option } = Select;

  const generateManifest = async () => {
    setLoading(true);
    let temp = [];
    let totalWeight = 0;
    let shipmentNum = 0;
    for (let i = 0; i < selectedRowKeys.length; i++) {
      let temp2 = {
        awbNumber: selectedRowKeys[i].awbNumber,
        status: "ADDED",
      };
      temp.push(temp2);
      totalWeight = +totalWeight + +selectedRowKeys[i].weight;
      shipmentNum = shipmentNum + 1;
    }

    let payload = {
      totalweight: +totalWeight.toFixed(2),
      shipmentNum,
      status: "LOCKED_BY_HUB",

      lastMileManifestShipment: [...temp],
    };
    const tokendata = JSON.parse(localStorage.getItem("userinfo"));

    let header = {
      token: tokendata?.accessToken,
      "SMCS-PREMISE-ID": hubid?.userInfo?.premiseId,
      "USER-ID": hubid?.userInfo?.userId,
    };
    let response = await API.Api(
      `${APIs.baseURL}/last-mile-manifest-service/v1/manifest/${
        manifrestId?.manifestId || manifestData?.manifestId
      }`
    ).patchCustomHeader(payload, header);
    if (response.status) {
      setTableData([]);
      setCpName(null);
      changeTab("2");
      setLoading(false);
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network error");
    }
  };

  return (
    <Spin spinning={loading}>
      <div>
        {/* <Heading title={"Generate Manifest"} /> */}
        <div className="master-main-container global-form ">
          <Row className="global-form-row p-2" gutter={10}>
            <Col md={4} sm={4} xsm={4}>
              {" "}
              <spna>CP</spna>
              <Select
                className="indepentedInput"
                showSearch
                placeholder="Select a CP"
                optionFilterProp="children"
                defaultValue={cpName}
                onChange={onChange}
                onSearch={onSearch}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {cpDropDown.map((option) => (
                  <Option key={option?.premiseId} value={option?.premiseId}>
                    {capitaliseWithHyphen(option?.premiseName)}
                  </Option>
                ))}
              </Select>
            </Col>
            <Col className="global-form-row" md={4} sm={4} xsm={4}>
              <spna>Hub</spna>
              <Input
                className="indepentedInput"
                placeholder="Enter AWB number"
                type="text"
                value={capitalize(hubid?.premises?.premiseName)}
                disabled={true}
              />
            </Col>
            <Col md={6} sm={8} xsm={4} style={{ paddingTop: "1.8rem" }}>
              <Button className="save-btn ml-1" onClick={handleScan}>
                INITIATE MANIFEST
              </Button>
            </Col>
          </Row>
          {tableData?.length > 0 && (
            <>
              <div className="p-2">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    {" "}
                    <spna className="cpName">CP Name:</spna>{" "}
                    <spna>
                      {" "}
                      {capitaliseWithHyphen(cpName) || "Bhulabhai"} CP
                    </spna>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      columnGap: "5px",
                    }}
                  >
                    {/* <RangePicker className="filter-input" /> */}
                    <div className="pointer">
                      <Dropdown
                        overlay={menu}
                        overlayClassName="nav-dropdown-overlay filter-order"
                        // open={true}
                        className="flter-drop-down"
                      >
                        <div
                          className="pointer"
                          style={{ display: "flex", flexDirection: "row" }}
                          onClick={(e) => e.preventDefault()}
                        >
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "400",
                              padding: "10px",
                            }}
                          >
                            Filter
                          </span>
                          <img src={filter_icon} height={20} />
                        </div>
                      </Dropdown>
                    </div>
                    <div className="reactangle-box">
                      {toFilter?.length > 0 ? (
                        <>
                          {selectedRowKeys?.length}/{toFilter?.length}
                        </>
                      ) : (
                        <>
                          {selectedRowKeys?.length}/{tableData?.length}
                        </>
                      )}
                    </div>
                  </div>
                </div>
                {/* <Row
                  className="global-form-row"
                  // gutter={10}
                  justify={"space-between"}
                >
                  <Col
                    sm={12}
                    md={8}
                    lg={6}
                    xl={4}
                    style={{ paddingTop: "10px" }}
                  >
                    <text>
                      {" "}
                      <spna className="cpName">CP Name:</spna>{" "}
                      <spna>
                        {" "}
                        {capitaliseWithHyphen(cpName) || "Bhulabhai"} CP
                      </spna>
                    </text>
                  </Col>
                  <Col
                    sm={12}
                    md={8}
                    lg={18}
                    xl={8}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      columnGap: "5px",
                    }}
                  >
                    <RangePicker className="filter-input" />
                    <div className="pointer">
                      <Dropdown
                        overlay={menu}
                        overlayClassName="nav-dropdown-overlay filter-order"
                        // open={true}
                        className="flter-drop-down"
                      >
                        <div
                          className="pointer"
                          style={{ display: "flex", flexDirection: "row" }}
                          onClick={(e) => e.preventDefault()}
                        >
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "400",
                              padding: "10px",
                            }}
                          >
                            Filter
                          </span>
                          <img src={filter_icon} height={20} />
                        </div>
                      </Dropdown>
                    </div>
                    <div className="reactangle-box">
                      {toFilter?.length > 0 ? (
                        <>
                          {selectedRowKeys?.length}/{toFilter?.length}
                        </>
                      ) : (
                        <>
                          {selectedRowKeys?.length}/{tableData?.length}
                        </>
                      )}
                    </div>
                  </Col>
                </Row> */}
              </div>
              <div className="manifest-table-container ">
                <Table
                  columns={columns}
                  dataSource={
                    tableData?.length > 0
                      ? filteredData?.length > 0
                        ? toFilter
                        : tableData
                      : []
                  }
                  // pagination={{
                  //   itemRender: itemRender,
                  // }}
                  pagination={false}
                  rowKey={(record) => record}
                  rowSelection={{
                    selectedRowKeys,
                    onChange: (selectedRowKeys, selectedRows, x) => {
                      setSelectedRowKeys(selectedRowKeys);
                    },
                  }}
                  // scroll={{
                  //   x: 1500,
                  //   y: 500,
                  // }}
                />
              </div>

              <Button
                className="save-btn ml-1"
                style={{ float: "right", margin: "10px" }}
                onClick={generateManifest}
              >
                GENERATE MANIFEST{" "}
              </Button>
            </>
          )}
        </div>
      </div>
    </Spin>
  );
}

export default GenerateManifest;
